module.exports = __webpack_public_path__ + "img/search-option.8ff5ff00.jpg";